import React from 'react'
import { Play, Pause } from 'lucide-react'

export const VoicePreviewButton: React.FC<{ isPlaying: boolean; onClick: (e: React.MouseEvent) => void }>
= ({ isPlaying, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={
      "shrink-0 inline-flex h-7 w-7 items-center justify-center rounded-full ring-1 ring-inset ring-black/10 text-foreground hover:bg-black/5"
    }
    aria-label={isPlaying ? 'Pause preview' : 'Play preview'}
  >
    {isPlaying ? (
      <Pause className="h-3.5 w-3.5" />
    ) : (
      <Play className="h-3.5 w-3.5" />
    )}
  </button>
)
